import React from 'react';
import useStyles from 'isomorphic-style-loader/useStyles';
import classNames from 'classnames';
import Tooltip from 'rc-tooltip';
import PropTypes from 'prop-types';

// assets
import CssBookRankOverlay from './BookRankOverlay.scss';

function BookRankOverlayTooltip(props) {
  const { ranking, size } = props;

  if (size === 'small' && ranking && ranking <= 100) {
    return (
      <div className="book-rank-overlay__tooltip">{`Ranked #${ranking} by 1000 Cookbooks`}</div>
    );
  }

  return <div className="book-rank-overlay__tooltip">Recommended by 1000 Cookbooks</div>;
}

function BookRankOverlay(props) {
  const { className, ranking, size, withLink, withTooltip, ...others } = props;
  const rankingPrefix = size === 'medium' ? 'TOP 1000 ' : '';
  useStyles(CssBookRankOverlay);

  if (ranking) {
    const rankingClassName = classNames(
      'book-rank-overlay',
      `book-rank-overlay--${size}`,
      className,
    );
    const WrapperTag = withLink ? 'a' : 'span';
    const WrapperAttrs = withLink
      ? {
          href: 'https://app.1000cookbooks.com/books',
          rel: 'noopener noreferrer',
          target: '_blank',
          alt: '1000 Cookbooks',
        }
      : {};

    const wrapper = (
      <WrapperTag {...WrapperAttrs} className={rankingClassName} {...others}>
        {ranking <= 100 ? (
          <React.Fragment>
            <p className="book-rank-overlay--space" />
            {rankingPrefix}#{ranking}
          </React.Fragment>
        ) : (
          'top 1000'
        )}
      </WrapperTag>
    );

    if (withTooltip) {
      return (
        <Tooltip
          overlay={<BookRankOverlayTooltip {...props} />}
          placement="top"
          mouseEnterDelay={0.75}
        >
          {wrapper}
        </Tooltip>
      );
    }
    return wrapper;
  }

  return null;
}

BookRankOverlayTooltip.propTypes = {
  ranking: PropTypes.number,
  size: PropTypes.oneOf(['small', 'medium']),
};

BookRankOverlayTooltip.defaultProps = {
  ranking: null,
  size: 'small',
};

BookRankOverlay.propTypes = {
  className: PropTypes.string,
  ranking: PropTypes.number,
  size: PropTypes.oneOf(['small', 'medium']),
  withLink: PropTypes.bool,
  withTooltip: PropTypes.bool,
};

BookRankOverlay.defaultProps = {
  className: null,
  ranking: null,
  size: 'small',
  withLink: false,
  withTooltip: true,
};

export default BookRankOverlay;
